import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getVatCodes(agencyId: number) {
  const data = await apiGet(`helper/vatCodes/agencyId/${agencyId}`);

  useHelperStore().setVatCodes({ agencyId, data });
}
